import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

export const TimeAmountIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <rect id="path-1" x="0" y="0" width="1920" height="380"></rect>
      </defs>
      <g id="УГУ" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="courses" transform="translate(-521.000000, -277.000000)">
          <g id="Group-5" transform="translate(1.000000, 93.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <path
              d="M380.713623,90.2853932 L843.617557,-146.02911 C848.499849,-148.521541 854.284415,-148.506783 859.153925,-145.98947 L1183.62255,21.7458619 C1191.96287,26.057419 1195.22882,36.3137854 1190.91726,44.6540975 C1189.28776,47.8062245 1186.71275,50.3694454 1183.55317,51.9844682 L751.578361,272.789492 C735.310328,281.104939 716.075128,281.269126 699.667518,273.232592 L380.935748,117.116087 C373.49598,113.47205 370.418933,104.486851 374.062971,97.0470831 C375.490201,94.1332094 377.823778,91.7606716 380.713623,90.2853932 Z"
              id="Path-2-Copy"
              stroke="#979797"
              opacity="0.0933547247"
              strokeDasharray="5"
              mask="url(#mask-2)"
            ></path>
          </g>
          <text
            id="17-студентов"
            opacity="0.508765811"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fill="#1A1E3D"
          >
            <tspan x="405" y="290">
              17 студентов
            </tspan>
          </text>
          <path
            d="M529.99985,277 C525.029427,277 521,281.029547 521,285.99985 C521,290.970153 525.029427,295 529.99985,295 C534.970273,295 539,290.970153 539,285.99985 C539,281.029547 534.970273,277 529.99985,277 Z M533.890735,287.711619 L530.075151,287.711619 C530.062251,287.711619 530.050251,287.708498 530.037471,287.708018 C530.02469,287.708618 530.01275,287.711619 529.99979,287.711619 C529.656044,287.711619 529.37734,287.432914 529.37734,287.089168 L529.37734,280.735002 C529.37734,280.391257 529.656044,280.112552 529.99979,280.112552 C530.343536,280.112552 530.62224,280.391257 530.62224,280.735002 L530.62224,286.466718 L533.890495,286.466718 C534.234241,286.466718 534.512945,286.745422 534.512945,287.089168 C534.512945,287.432914 534.234481,287.711619 533.890735,287.711619 Z"
            id="Shape"
            // fill={colors.uguPurple}
            fill="#7181FF"
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export const TimeAmountIconNew: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.99985C0 4.02955 4.02943 0 8.99985 0C13.9703 0 18 4.02955 18 8.99985C18 13.9702 13.9703 18 8.99985 18C4.02943 18 0 13.9702 0 8.99985ZM9.07515 10.7116H12.8907C13.2345 10.7116 13.5129 10.4329 13.5129 10.0892C13.5129 9.74542 13.2342 9.46672 12.8905 9.46672H9.62224V3.735C9.62224 3.39126 9.34354 3.11255 8.99979 3.11255C8.65604 3.11255 8.37734 3.39126 8.37734 3.735V10.0892C8.37734 10.4329 8.65604 10.7116 8.99979 10.7116C9.00699 10.7116 9.01387 10.7107 9.02075 10.7098C9.02627 10.709 9.03179 10.7083 9.03747 10.708C9.04333 10.7082 9.04903 10.709 9.05472 10.7098C9.06144 10.7107 9.06817 10.7116 9.07515 10.7116Z"
        fill="#1A1E3D"
      />
    </svg>
  )
}
